// Contract types based on the ABI
export interface LoanApplication {
	borrower: string;
	amount: bigint;
	collateral: bigint;
	isVerified: boolean;
	verificationRequestId: string;
	status: LoanStatus;
	timestamp: bigint;
	expiresAt: bigint;
}

export enum LoanStatus {
	Pending = 0,
	VerificationRequested = 1,
	VerificationCompleted = 2,
	Approved = 3,
	Rejected = 4,
	Repaid = 5,
}

export interface ContractConstants {
	MAX_VERIFICATION_AGE: bigint;
	MIN_LOAN_AMOUNT: bigint;
	MIN_COLLATERAL_RATIO: bigint;
	DEFAULT_ADMIN_ROLE: string;
	HUMANITY_ORACLE_ROLE: string;
	UPGRADER_ROLE: string;
	REQUIRED_CLAIMS: string[]; // Assuming this is an array of strings
}

export interface LoanApplicationDetails {
	amount: bigint;
	collateral: bigint;
	isVerified: boolean;
	status: LoanStatus;
	timestamp: bigint;
	expiresAt: bigint;
	verificationRequestId?: string;
}

// Wallet-related types
export interface WalletConnectionResult {
	success: boolean;
	account?: string;
	error?: string;
}

export interface WalletError {
	code: number;
	message: string;
}

export interface SwitchNetworkParams {
	chainId: string;
	chainName?: string;
	nativeCurrency?: {
		name: string;
		symbol: string;
		decimals: number;
	};
	rpcUrls?: string[];
	blockExplorerUrls?: string[];
}

export interface ApplyVerificationResult {
	user: string
	requester: string
	requestUID: string
	verified: boolean
	expiresAt: bigint
	revocationTime: bigint
	usedIssuers: string[]
	usedCategories: string[]
}